module.exports = __webpack_public_path__ + "static/media/fieldpic.d61e0abb.JPG";